<div class="stepper-wrap">
  <app-register-trailer-stepper></app-register-trailer-stepper>
</div>
<div class="side-img-wrap">

</div>
